<template>
  <div>
    <v-row justify="center" align="start">
      <v-col cols="12" md="8" sm="12">
        <v-img :src="logo" class="my-3" contain height="200" />
        <div :style="companyStyle">{{ companyHomePageText }}</div>
      </v-col>
      <v-col cols="12" md="12" sm="12">
        <v-row class="pa-0" justify="center" align="start">
          <v-col cols="12" md="10" sm="12">
            <v-btn
              @click="OrderHereRedirect()"
              color="primary"
              class="white--text"
              block
              x-large
              >Order Here</v-btn
            >
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="10" sm="12">
        <v-row
          v-if="$store.getters.retrieveSelectedCustomer != null"
          class="pa-0 fill-height"
          justify="space-between"
          align="stretch"
        >
          <v-col cols="12" md="6" sm="12">
            <v-card :loading="loadingCustomer" outlined>
              <div v-if="loadingCustomer">
                <v-card-title>Loading Customer</v-card-title>
              </div>
              <SelectedAddress
                v-else-if="
                  $store.getters.retrieveIsCashCustomer &&
                  $store.getters.retrieveSelectedAddress
                "
                :showSelectAddress="false"
                :outlined="false"
              />
              <CustomerAddress
                v-else-if="retrieveCustomerAddress"
              ></CustomerAddress>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <v-card outlined style="height: 100%">
              <BasketOverview :loadingBasket="loadingBasket" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectedAddress from "@/components/deliveryAddresses/SelectedAddress.vue";
import CustomerAddress from "@/components/customer/CustomerAddress.vue";
import BasketOverview from "@/components/dashboard/BasketOverview.vue";

export default {
  name: "Home",

  components: {
    SelectedAddress,
    CustomerAddress,
    BasketOverview,
  },

  props: {
    loadingBasket: Boolean,
  },

  data: () => ({
    loadingCustomer: false,

    showDialog: false,
    getSurveyData: {},
  }),

  computed: {
    ...mapGetters(["retrieveCustomerAddress"]),

    logo() {
      return require(process.env.VUE_APP_LOGO_MAIN);
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    companyHomePageText() {
      return this.$store.getters.retrieveCompanyHomePageText;
    },

    companyStyle() {
      const Style = {
        color: this.$vuetify.theme.themes[this.theme].primary,
        "text-align": "center",
        "font-size": "4rem !important",
        "font-weight": 400,
        // "line-height": "3.125rem",
        "letter-spacing": "normal !important",
        "font-family": "Roboto, sans-serif !important",
      };

      console.log("-- Checking Style");
      console.log(this.$store.getters.retrieveAllConfigs);
      console.log(
        this.$store.getters.retrieveAllConfigs.company_home_page_text_font_size
      );

      if (
        this.$store.getters.retrieveAllConfigs.company_home_page_text_font_size
      ) {
        Style["font-size"] =
          this.$store.getters.retrieveAllConfigs
            .company_home_page_text_font_size + "px";
      }

      return Style;
    },

    trolly() {
      return this.$store.getters.retrieveCurrentTrolly;
    },
  },

  methods: {
    OrderHereRedirect() {
      if (this.trolly) {
        this.$router.push({ name: "OrdersSearch" }).catch((e) => {
          console.log(e);
          return false;
        });
        return;
      } else if (this.$store.getters.retrieveHasMultipleTrollys) {
        //Push Search first because when we go back from selecting a basket we want to be on the search page
        this.$router.push({ name: "OrdersSearch" }).catch((e) => {
          console.log(e);
          return false;
        });

        this.$router.push({ name: "OrdersBasketSelection" }).catch((e) => {
          console.log(e);
          return false;
        });
        return;
      } else {
        this.$router.push({ name: "OrdersCreate" }).catch((e) => {
          console.log(e);
          return false;
        });
        return;
      }
    },
  },
};
</script>


<style lang="sass">
</style>
